import logo1985_1992 from "../../assets/img/historicEvents/LogoSNME/1985-1992.png";
import logo1992 from "../../assets/img/historicEvents/LogoSNME/1992.png";
import logo2006_2008 from "../../assets/img/historicEvents/LogoSNME/2006-2008.png";
import logo2024_2026 from "../../assets/img/historicEvents/LogoSNME/2024-2026.png";
import logo2025 from "../../assets/img/historicEvents/LogoSNME/2025.png";
import logo2026NYC from "../../assets/img/historicEvents/LogoSNME/2026NYC.png";
import logo2026 from "../../assets/img/historicEvents/LogoSNME/2026SNME.png";

export const saturdayNightsMainEventDetail = {
  id: "saturday-nights-main-event",
  title: "Saturday Night's Main Event",
  subtitle: "Explore the event editions in a dedicated event view.",
  tabs: [
    {
      id: "logos",
      label: "Editions",
      variant: "saturday-nights-main-event",
      items: [
        {
          id: "snme-1985",
          title: "Saturday Night's",
          description: " Main Event 1985 - 1992",
          imgUrl: logo1985_1992,
        },
        {
          id: "snme-1992",
          title: "Saturday Night's",
          description: " Main Event 1992",
          imgUrl: logo1992,
        },
        {
          id: "snme-2006",
          title: "Saturday Night's",
          description: "Main Event 2006 - 2008",
          imgUrl: logo2006_2008,
        },
        {
          id: "snme-2024",
          title: "Saturday Night's",
          description: "Main Event 2024 - 2025",
          imgUrl: logo2024_2026,
        },
        {
          id: "snme-2025",
          title: "Saturday Night's",
          description: "Main Event: No One Spared. Everyone Speared. 2025",
          imgUrl: logo2024_2026,
        },
        {
          id: "snme-20252",
          title: "Saturday Night's",
          description: "Main Event 2025",
          imgUrl: logo2024_2026,
        },
        {
          id: "snme-20253",
          title: "Saturday Night's",
          description: "Main Event: The Last Real Champion. One Last Time 2025",
          imgUrl: logo2025,
        },
        {
          id: "snme-2026-nyc",
          title: "Saturday Night's",
          description: "Main Event: Join the Uncursed. 2026",
          imgUrl: logo2026NYC,
        },
        {
          id: "snme-2026",
          title: "Sunday Night's",
          description: "Main Event 2026",
          imgUrl: logo2026,
        },
      ],
    },
  ],
};
